import { useState, Fragment, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import FormRequired from "../Shared/FormRequired";
import APIService from "../../services/Api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Notify from "../../toast/Notify";
import { UseAuth } from "../../auth/AuthContext";
import { GrSecure } from "react-icons/gr";
import { AES } from "crypto-js";
import DialogInfoGeneral from "../Shared/DialogInfoGeneral";
import RegisterPreForm from "../Register/RegisterPreForm";
import { classNames, getProfileDefaultImage } from "src/helpers/mixins";
import { useAppStateContext } from "src/auth/AppStateContext";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import ViewVideoCompany from "../Dashboard/ViewVideoCompany";

type ILogin = {
  email: string;
  password: string;
};

const LoginForm = () => {
  const { showRegisterPopup, setShowRegisterPopup, goLogin, setGoLogin } = useAppStateContext();
  const [rememberUser, setRememberUser] = useState<boolean>(true);
  const [userRemembered, setUserRemembered] = useState<string>("");
  const [profilePictureRemembered, setProfilePictureRemembered] =
    useState<string>("");
  const [inputType, setInputType] = useState<string>("password");
  const { t } = useTranslation();
  const [accountDisabled, setAccountDisabled] = useState<boolean>(false);
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ILogin>();
  const [attemp, setAttemp] = useState<number>(0);
  const navigate = useNavigate();
  const { setUserData } = UseAuth();

  const targetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if(goLogin){
      scrollGoToLogin()
      setGoLogin(false)
    }
  }, [goLogin]);


  useEffect(() => {
    if (
      localStorage.getItem("rememberUser") &&
      (localStorage.getItem("rememberUser") || "").length > 0
    ) {
      setUserRemembered(localStorage.getItem("rememberUser") || "");
      setProfilePictureRemembered(
        localStorage.getItem("profilePictureUser") || ""
      );
      setValue("email", localStorage.getItem("rememberUser") || "");
    }
  }, []);

  const handleSendCode = async (emailtosend: string) => {
    const response = await APIService.userRecoverAccount({
      email: emailtosend,
    });
    if (response.data.status) {
      localStorage.setItem("emailrecover", emailtosend);
      navigate("/recover", {
        state: {
          action: "blockedaccount",
          emailtosend,
        },
      });
    } else {
      if (response.data.message === "usernotfound") {
        Notify(t("usernotfound"));
      }
    }
  };

  const handleLogin = async (data: ILogin) => {
    //const env = process.env.REACT_APP_ENV
    const password = AES.encrypt(
      data.password,
      process.env.REACT_APP_SECRET_KEY || "SlllM3L$uN<>w32r"
    );
    try {
      setAccountDisabled(false);
      const login = await APIService.userLogin({
        email: data.email,
        password: password.toString(),
      });
      if (rememberUser) {
        localStorage.setItem("rememberUser", data.email);
      } else {
        localStorage.removeItem("rememberUser");
        localStorage.removeItem("profilePictureUser");
      }
      if (login.data.status) {
        localStorage.setItem("authToken", login.data.data.authToken);
        let ip = login?.data?.data?.ip || "desconocido";

        try {
          await fetch("https://api.ipify.org?format=json")
            .then((response) => response.json())
            .then((data) => (ip = data.ip));
          const { detect } = require("detect-browser");
          const browser = detect();
          console.log(browser);
          const info = {
            browser: browser?.name || "",
            os: browser?.os || "",
            type: browser?.type || "",
            version: browser?.version || "",
            ip,
          };
          await APIService.systemLoginHistory({
            info: JSON.stringify(info),
            token: login?.data?.data?.authToken || "",
          });
        } catch (e) {
          console.log("error es el siguiente " + e);
        }
        Notify(login.data.message);
        const user = login.data.data.user;
        setUserData(
          user.id,
          user.email,
          user.fullname,
          user.phone,
          user.country,
          user.birthday,
          user.verifyAccount,
          user.role,
          user.verifiedIdentity,
          user.createdAt,
          user.photoUrl,
          user.nickname || "",
          user.lastConnection || ''
        );
        navigate("/inicio");
      } else {
        if (login?.data?.data?.attemp && login.data.data.attemp >= 5) {
          handleSendCode(data.email);
        }
        if (login?.data?.data?.attemp) {
          setAttemp(login.data.data.attemp);
        }
        Notify(login.data.message);
        if (login.data.message === "Cuenta inhabilitada") {
          setAccountDisabled(true);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const scrollGoToLogin = () => {
    console.log('yendo al login')
    if (targetRef.current) {
      console.log('entrando aca')
      targetRef.current.scrollIntoView({ behavior: 'smooth' }); // 'auto' o 'smooth'
    }
  };

  return (
    <div ref={targetRef}>
      <ToastContainer
        position="bottom-center"
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <section className="beClient flex flex-col items-center justify-center">
 {/*        <div className="video-overlay-login"></div> */}
        <div className="" style={{zIndex:"2"}}>
          <div className="grid grid-cols-1  md:grid-cols-2">
            <div className="col-span-1 pb-20 md:pb-0 order-last md:order-first">
              <div className="text-4xl font-bold text-white "></div>
              <div
                className={classNames("text-base sm:text-xl md:text-[2.5rem] md:leading-[3rem] lg:text-[3.5rem] lg:leading-[4rem] xl:text-[3.5rem] xl:px-10 xl:leading-[4rem] text-center md:text-right xl:text-right flex-col items-center justify-center font-semibold titleOne fadein")}
              >
                Intercambia tus saldos digitales.
                <br />
                en cualquier momento <br />
                fácil y seguro.
                <div className="titleTwo  text-base md:text-[1rem] md:leading-[1rem] opensans xl:text-[1.2rem] xl:leading-[2rem] text-center md:text-left xl:text-right text-white">
                  ¡Confiable, seguro amigable & eficaz! ¡Envia dinero a tu cuenta!
                  <br />
                  Conviertete en cajero y gana comisiones
                </div>
                <div>
                  <ViewVideoCompany />
                </div>
              </div>
            </div>
            <div className="col-span-1 mt-10 md:mt-0">
              <div className="grid px-3 sm:px-4 md:px-6 xl:px-0 xl:grid-cols-2 grid-cols-1  gap-4 flex flex-wrap">
                <div className="body-loginold">
                  <section className="body-login-container">
                    <div className="text-center mt-2  fadeinbottom text-3xl lg:text-3xl pt-1 lg:pt-10 text-white underline">
                      {t("login")}
                    </div>
                    
                    {accountDisabled && (
                      <div className="w-full lg:w-11/12 mx-auto py-4 px-2 text-center mt-10 bg-green-admin-light text-white rounded-md ">
                        <div className="text-xl font-bold">
                          {t("youraccountwasdisable")}
                        </div>
                        <div>{t("youraccountwasdisableInfo")}</div>
                      </div>
                    )}
                    {attemp > 0 && attemp <= 4 ? (
                      <Fragment>
                        <div className="text-center font-medium text-red-400">
                          Intento {attemp} de 5
                        </div>
                        <div className="text-xs flex items-center gap-x-1 text-left font-normal bg-gray-300 border-gray-200 w-4/5 mx-auto p-2 rounded-sm">
                          <GrSecure size={40} />
                          {t("blockedaccount1")}
                        </div>
                      </Fragment>
                    ) : (
                      attemp >= 5 && (
                        <div className="text-center bg-red-200 w-fit mx-auto p-2 rounded-sm">
                          {t("blockedaccount3")}
                        </div>
                      )
                    )}
                    <form
                      onSubmit={handleSubmit(handleLogin)}
                      action="javascript:void(0)"
                      className="mt-3 mx-auto opensans"
                    >
                      <div className="flex flex-col">
                        <div>
                          {((userRemembered.length || 0 )> 0 && (profilePictureRemembered?.length || 0) > 0) && 
                            <div className="flex px-2 py-2 rounded-md items-center gap-2 bg-white">
                              <div
                                className="w-12 h-12 bg-cover bg-center rounded-full"
                                style={{
                                  backgroundImage: `url(${
                                    (localStorage.getItem("profilePictureUser") !== "null")
                                      ? process.env.REACT_APP_PROFILEPICTURE +
                                        (profilePictureRemembered || "")
                                      : getProfileDefaultImage()
                                  })`,
                                }}
                              ></div>
                              <div className="text-sm font-bold">
                                {userRemembered}
                              </div>
                            </div>
                          }
                          <label
                            htmlFor="email"
                            className="text-white text-xl font-bold text-center lg:text-left"
                          >
                            {t("email")}
                          </label>
                        </div>
                        <input
                          type="text"
                          id="email"
                          defaultValue={userRemembered}
                          {...register("email", {
                            required: true,
                            maxLength: 50,
                          })}
                          className="border px-2 border-gray w-full h-10 rounded-md py-6 bg-white"
                        />
                        {errors.email && <FormRequired />}
                      </div>
                      <div className="flex flex-col mt-5 ">
                        <div className="flex flex-wrap justify-between  ">
                          <label
                            htmlFor="password"
                            className="text-white text-xl font-bold text-center  lg:text-left"
                          >
                            {t("password")}
                          </label>
                        </div>
                        <div className="border flex items-center gap-2 bg-white rounded-md border-stone-200">
                          <input
                            type={inputType || "password"}
                            id="password"
                            {...register("password", {
                              required: true,
                              maxLength: 50,
                            })}
                            className="border px-2 border-gray  text-xl h-15 w-full h-10 rounded-md py-6 bg-white"
                          />
                          {inputType !== "password" ? (
                            <FaRegEye
                              className="text-black cursor-pointer"
                              size={33}
                              onClick={() => setInputType("password")}
                            />
                          ) : (
                            <FaRegEyeSlash
                              className="text-black cursor-pointer"
                              size={33}
                              onClick={() => setInputType("text")}
                            />
                          )}
                        </div>
                        {errors.password && <FormRequired />}
                      </div>

                      <div className="form-check mt-2">
                        <input
                          className="form-check-input h-4 w-4 border-2 border-dark-green  rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                          type="checkbox"
                          checked={rememberUser}
                          name="rememberUser"
                          id="checkRememberedUser"
                          onClick={() => setRememberUser(!rememberUser)}
                        />
                        <div
                          className="form-check-label inline-block text-white select-none"
                          onClick={() => setRememberUser(!rememberUser)}
                        >
                          {t("rememberuser")}
                        </div>
                      </div>
                      <div>
                        {!isSubmitting ? (
                          <>
                            {attemp < 5 && (
                              <button
                                type="submit"
                                className="mt-8 fadeintop bg-[#2d7b5c] w-fit text-white rounded-md py-4 px-8 w-full text-2xl"
                              >
                                {t("enter")}
                              </button>
                            )}
                          </>
                        ) : (
                          <button
                            type="button"
                            disabled
                            className="mt-8 w-full px-20 bg-[#2d7b5c]  text-white  text-center rounded-md py-6 w-fit-content lg:m-1/2 text-2xl flex justify-center "
                          >
                            <div className="loader-dots"></div>
                          </button>
                        )}
                      </div>
                      <div>
                        <div className="flex items-center gap-4 justify-center  mt-8 ">
                          <h2 className="text-white font-bold ">
                            {t("noaccount")}{" "}
                          </h2>
                          <div
                            onClick={() => setShowRegisterPopup(true)}
                            className="bg-red-500 cursor-pointer text-white px-6 py-1 text-xl rounded-md"
                          >
                            {t("register")}
                          </div>
                        </div>
                      </div>
                    </form>
                    <Link to="/recover">
                              <span className="text-white cursor-pointer font-semibold opensans  lg:inline ">
                                {t("forgotpassword")}
                              </span>
                            </Link>
                  </section>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      <DialogInfoGeneral
        disabledFooter={true}
        size={"xl"}
        show={showRegisterPopup}
        closeDialog={() => setShowRegisterPopup(false)}
        children={<RegisterPreForm />}
      />
      {/*   <Footer /> */}
    </div>
  );
};
export default LoginForm;
